<template>
    <div class="flex flex-no-wrap">
        <vue-button icon="minus"
                    @click="decrement"
                    type="button"
                    class="btn btn-primary btn-ghost text-gray rounded-r-none border-r-0 flex-no-shrink"
                    icon-class="svg-lg"
                    v-if="!disabled"/>
        <vue-input :id="id"
                   :input-class="`text-center ${!disabled ? 'rounded-none' : ''}`"
                   type="number"
                   @change="handleChange"
                   v-model="model"
                   :clearable="false"
                   :disabled="disabled"/>
        <vue-button icon="add"
                    type="button"
                    class="btn btn-primary btn-ghost text-gray rounded-l-none border-l-0 flex-no-shrink"
                    icon-class="svg-lg"
                    @click="increment"
                    v-if="!disabled"/>
    </div>
</template>

<script>
export default {
  props: {
    value: {},

    min: {
      type: Number,
      default: 0,
    },

    max: {
      type: Number,
      default: null,
    },

    step: {
      type: Number,
      default: 1,
    },

    id: {
      type: String,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    model: {
      get() {
        return this.value !== null ? Number(this.value) : null;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    decrement() {
      if (this.model === 0) {
        this.model = null;
        return;
      }
      if (this.model <= this.min) {
        return;
      }
      this.model = this.model - this.step;
    },

    increment() {
      if (this.model === null) {
        this.model = 0;
        return;
      }
      if (this.max && this.model >= this.max) {
        return;
      }
      this.model = this.model + this.step;
    },

    handleChange(event) {
      let number = Number(event.target.value);
      if (number < this.min) number = this.min;
      if (this.max && number > this.max) number = this.max;
      this.model = number;
    },
  },
};
</script>